export default __webpack_public_path__ + "static/media/docs-burnout-symptoms-quantity-head.452536b8.png";